import { render, staticRenderFns } from "./SponsorPreview.vue?vue&type=template&id=396a9f22&scoped=true"
import script from "./SponsorPreview.vue?vue&type=script&lang=js"
export * from "./SponsorPreview.vue?vue&type=script&lang=js"
import style0 from "./SponsorPreview.vue?vue&type=style&index=0&id=396a9f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396a9f22",
  null
  
)

export default component.exports